'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ErrorMessages=require('../../../../../../dist-es6/client/errorMessages');
const GenerateEnum=require('pulsar-utils/dist-es6/domain/generateEnum');
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');
const BaseService=require('../../../../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const DutyViewModel=require('../../../../../../dist-es6/client/viewModels/dutyViewModel');
const TripViewModel=require('../../../../../../dist-es6/client/viewModels/tripViewModel');
const EmiratesSearchType=require('../../../../../../dist-es6/client/features/emirates/emiratesDashboard/domain/emiratesSearchType');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const{SocketTimeoutError:SocketTimeoutError}=require('../../../../../../dist-es6/client/services/socketService');

const DefaultServiceParams={
hasPerformedSearch:!1,
currentSearchType:null,
_readyToSearch:!1,
_searchInProgress:!1};


const _RetryOptions={
retries:5,
maxTimeout:30000,
randomize:!0};


const parametersBySearchType=new Map([
[EmiratesSearchType.PairingOrFlight,{
required:['pairing','activityCodes','crewRank']}],

[EmiratesSearchType.DateAndTime,{
required:['date','numDaysAvailable','timeOfDay','activityCodes','crewRank'],
optional:['fleets']}],

[EmiratesSearchType.StaffId,{
required:['staff']}]]);



const _emiratesSearchErrorMessagesByStatus={
NoScheduleUpdateForPairing:'Unable to create schedule update for selected pairing criteria. Please check your search parameters and try again. If the problem persists please contact technical support.'};let


EmiratesSearchService=function(_BaseService){_inherits(EmiratesSearchService,_BaseService);
function EmiratesSearchService($timeout,dateService,userService,socketService,scheduleService,timeZoneService,notificationService,organizationDefaultsService){_classCallCheck(this,EmiratesSearchService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._$timeout=$timeout;
_this._dateService=dateService;
_this._userService=userService;
_this._socketService=socketService;
_this._scheduleService=scheduleService;
_this._timeZoneService=timeZoneService;
_this._notificationService=notificationService;
_this._organizationDefaultsService=organizationDefaultsService;

_.defaults(_this,DefaultServiceParams);return _this;
}EmiratesSearchService.prototype.





updateSearchParameters=function updateSearchParameters(selectedSearchType){let parameters=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};
this.currentSearchType=selectedSearchType;
const{
required:requiredParams,
optional:optionalParams}=
parametersBySearchType.get(selectedSearchType);
this.parameters=_.pick(parameters,requiredParams.concat(optionalParams));

this._readyToSearch=parametersBySearchType.get(selectedSearchType).required.every(function(parameterName){
if(!_.exists(parameters[parameterName])){
return!1;
}

const value=parameters[parameterName];
if((_.isString(value)||_.isArray(value))&&value.length===0){
return!1;
}

return!0;
});

this._isSameParametersAsLastSearch=this.hasPerformedSearch&&_.exists(this._lastParameters)&&_.isEqual(this._lastParameters,{
type:this.currentSearchType,
parameters:_.cloneDeep(this.parameters)});

};EmiratesSearchService.prototype.

performSearch=function(){var ref=_asyncToGenerator(function*(){var _this2=this;let{isRefresh=!1,isAuto=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
const searchConfig=isRefresh?this._lastParameters:{
type:this.currentSearchType,
parameters:_.cloneDeep(this.parameters)};


this._searchInProgress=isAuto?!1:!0;
let results;
try{
results=yield this._getResultsFor(searchConfig,isAuto);
}finally{
this._searchInProgress=!1;
}

if(results.results&&results.results.length===0&&!isRefresh){
return'NoResults';
}

this.hasPerformedSearch=!0;

if(!isRefresh){
this._$timeout(function(){return _this2.updateSearchParameters(_this2.currentSearchType,_this2.parameters)});
}

this._lastParameters=searchConfig;

return results;
});function performSearch(){let{isRefresh=!1,isAuto=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};return ref.apply(this,arguments)}return performSearch}();EmiratesSearchService.prototype.

_getResultsFor=function(){var ref=_asyncToGenerator(function*(){let{type:type,parameters:parameters}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};let isAuto=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;
const promisedOrganizationThresholds=this._organizationDefaultsService.getOrganizationThresholds({
keepSessionAlive:!isAuto,
retryOptions:_RetryOptions,
throwOnUnexpectedError:!0});


switch(type){
case EmiratesSearchType.PairingOrFlight:
return yield this._getPairingOrFlightResults(parameters,promisedOrganizationThresholds);

case EmiratesSearchType.DateAndTime:
return yield this._getDateAndTimeResults(parameters,promisedOrganizationThresholds);

case EmiratesSearchType.StaffId:
return yield this._getStaffIdResults(parameters,promisedOrganizationThresholds,isAuto);}


throw new Error(`Bad selectedSearchType, got: ${type}`);
});function _getResultsFor(){let{type:type,parameters:parameters}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};let isAuto=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;return ref.apply(this,arguments)}return _getResultsFor}();EmiratesSearchService.prototype.

_getPairingOrFlightResults=function(){var ref=_asyncToGenerator(function*(parameters,promisedOrganizationThresholds){
const response=yield this._fetchResults('RunScenariosForPairing',parameters,{timeoutInSeconds:500*.25*3});
const{fatigueThreshold:fatigueThreshold}=yield promisedOrganizationThresholds;
if(!_.exists(response.outputInterval)){
return response;
}

const flightIndexFromSelection=_.exists(parameters.pairing.flightNumber)?parameters.pairing.flights.map(function(f){return f.flightNumber}).indexOf(parameters.pairing.flightNumber):null;

const{outputInterval:outputInterval,referenceScenario:referenceScenario,results:results}=response;
_inflateStartAndEndDates(outputInterval);
const additionalProperties={selectedFlightIndex:flightIndexFromSelection,crewRank:parameters.crewRank};

return{
referenceScenario:inflateIndividualsResultsFromBackend({scenario:referenceScenario},{outputInterval:outputInterval,fatigueThreshold:fatigueThreshold},additionalProperties),
outputInterval:outputInterval,
flightIndexFromSelection:flightIndexFromSelection,
results:_(results).
map(function(result){return inflateIndividualsResultsFromBackend(result,{outputInterval:outputInterval,fatigueThreshold:fatigueThreshold},additionalProperties)}).
sortBy(_thresholdStatusSort).
map(_withIndexAssigned).
value()};

});function _getPairingOrFlightResults(parameters,promisedOrganizationThresholds){return ref.apply(this,arguments)}return _getPairingOrFlightResults}();EmiratesSearchService.prototype.

_getDateAndTimeResults=function(){var ref=_asyncToGenerator(function*(parameters,promisedOrganizationThresholds){
const dateAndTimeRequest={
timezone:this._timeZoneService.localTimeZone,
day:this._dateService.getLocalDateStringFor(parameters.date),
time:parameters.timeOfDay,
totalDays:parameters.numDaysAvailable,
rank:parameters.crewRank,
activityCodes:parameters.activityCodes,
fleets:parameters.fleets};

const response=yield this._fetchResults('RunScenariosForTakeoffTime',dateAndTimeRequest,{timeoutInSeconds:500*.1*3});
const{fatigueThreshold:fatigueThreshold}=yield promisedOrganizationThresholds;
if(!_.exists(response.outputInterval)){
return response;
}

const{outputInterval:outputInterval,referenceScenario:referenceScenario,results:results}=response;
_inflateStartAndEndDates(outputInterval);
const additionalProperties={crewRank:parameters.crewRank};

return{
referenceScenario:inflateIndividualsResultsFromBackend({scenario:referenceScenario},{outputInterval:outputInterval,fatigueThreshold:fatigueThreshold},additionalProperties),
outputInterval:outputInterval,
results:_(results).
map(function(result){return inflateIndividualsResultsFromBackend(result,{outputInterval:outputInterval,fatigueThreshold:fatigueThreshold},additionalProperties)}).
sortBy(_takeoffFatigueAndThresholdStatusSort).
map(_withIndexAssigned).
value()};

});function _getDateAndTimeResults(parameters,promisedOrganizationThresholds){return ref.apply(this,arguments)}return _getDateAndTimeResults}();EmiratesSearchService.prototype.

_getStaffIdResults=function(){var ref=_asyncToGenerator(function*(parameters,promisedOrganizationThresholds,isAuto){
const timezone=this._timeZoneService.localTimeZone;
const startDay=CalendarDay.calendarDayFor({time:this._dateService.now(),timezone:timezone});

const rankByStaffNumber=new Map;
for(const staffMember of parameters.staff){
rankByStaffNumber.set(staffMember.staffNumber,staffMember.mostRecentQualifiedRank);
}

const upcomingFlightsRequest={
timezone:timezone,
startDay:startDay.toString(),
totalDays:30,
employeeIds:parameters.staff.map(function(s){return s.staffNumber})};


const response=yield this._fetchResults('GetUpcomingFlights',upcomingFlightsRequest,{
timeoutInSeconds:30+.5*(upcomingFlightsRequest.employeeIds.length-1),
keepSessionAlive:!isAuto});

const{fatigueThreshold:fatigueThreshold}=yield promisedOrganizationThresholds;
if(!_.exists(response.outputInterval)){
return response;
}

const{outputInterval:outputInterval,results:results}=response;
_inflateStartAndEndDates(outputInterval);

return{
outputInterval:outputInterval,
results:_(results).
map(function(result){return inflateIndividualsResultsFromBackend(result,{outputInterval:outputInterval,fatigueThreshold:fatigueThreshold},{crewRank:rankByStaffNumber.get(result.employeeId)})}).
sortBy('employeeId').
value()};

});function _getStaffIdResults(parameters,promisedOrganizationThresholds,isAuto){return ref.apply(this,arguments)}return _getStaffIdResults}();EmiratesSearchService.prototype.

_fetchResults=function(){var ref=_asyncToGenerator(function*(handler,request,_ref){let{timeoutInSeconds:timeoutInSeconds,keepSessionAlive=!0}=_ref;
_.ensureInstanceOf('number',timeoutInSeconds);
_.ensureInstanceOf('boolean',keepSessionAlive);
this._lastRequest=_.cloneDeep(request);
const socketResponse=yield this._socketService.sendAndWaitForResponse(
handler,
request,{
timeoutInSeconds:timeoutInSeconds,
retryOptions:_RetryOptions,
throwOnUnexpectedError:!0,
keepSessionAlive:keepSessionAlive});


if(SocketResponse.succeeded(socketResponse)){
return socketResponse.body;
}

const errorMessage=_emiratesSearchErrorMessagesByStatus[_.get(socketResponse,'status')]||ErrorMessages.OopsTryAgain;
this._notificationService.displayNotification(errorMessage,'error');
return{outputInterval:null,referenceScenario:null,results:[]};
});function _fetchResults(handler,request,_ref2){let{timeoutInSeconds:timeoutInSeconds,keepSessionAlive=!0}=_ref2;return ref.apply(this,arguments)}return _fetchResults}();_createClass(EmiratesSearchService,[{key:'parametersForCurrentResults',get:function()

{
return this._lastParameters;
}},{key:'searchInProgress',get:function()

{
return this._searchInProgress;
}},{key:'readyToSearch',get:function()

{
return this._readyToSearch;
}},{key:'isSameParametersAsLastSearch',get:function()

{
return this._isSameParametersAsLastSearch;
}}],[{key:'parametersBySearchType',get:function(){return parametersBySearchType}}]);return EmiratesSearchService}(BaseService);


const _statusImpactMap={
"above-threshold":2,
"at-threshold":1,
"below-threshold":0};


const inflateIndividualsResultsFromBackend=function(_ref3,_ref4){let{employeeId:employeeId,scenario={},schedule={}}=_ref3;let{outputInterval:bounds,fatigueThreshold:fatigueThreshold}=_ref4;let additionalProperties=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};
if(!_.exists(fatigueThreshold)){
throw new Error('Fatigue Threshold not provided!');
}

if(!_.exists(bounds)){
throw new Error('Bounds not provided!');
}

const scenarioTrips=_inflateTrips(scenario.trips,fatigueThreshold);
const impactedTrips=_inflateTrips(schedule.trips,fatigueThreshold);
const combinedTrips=scenarioTrips.concat(impactedTrips);

const scenarioDuties=_inflateDuties(scenario.duties,fatigueThreshold);
const impactedDuties=_inflateDuties(schedule.duties,fatigueThreshold);
const combinedDuties=scenarioDuties.concat(impactedDuties);

return _.defaults({
employeeId:employeeId,
bounds:bounds,
takeoff:_.exists(scenario.takeoff)?_inflateTakeoff(scenario.takeoff,fatigueThreshold):null,
trips:combinedTrips,
duties:combinedDuties,
impact:impactedTrips.reduce(function(acc,trip){
return acc+=_statusImpactMap[trip.tod.thresholdStatus.scenario]>_statusImpactMap[trip.tod.thresholdStatus.original]?1:0;
},0),
scenario:scenario,
schedule:schedule},
additionalProperties);
};

const _inflateStartAndEndDates=function(jsonInterval){
jsonInterval.start=new Date(jsonInterval.start);
jsonInterval.end=new Date(jsonInterval.end);
};

const _getSortCounterFor=function(type,status){return function(personResult){return personResult[type].trips.filter(function(trips){return(trips.tod.thresholdStatus.scenario||trips.tod.thresholdStatus.original)===status}).length}};

const _thresholdStatusSort=[
_getSortCounterFor('scenario','above-threshold'),
_getSortCounterFor('scenario','at-threshold'),

_getSortCounterFor('schedule','above-threshold'),
_getSortCounterFor('schedule','at-threshold'),




function(s){return Math.max.apply(Math,_toConsumableArray(s.scenario.trips.map(function(t){return t.tod.fatigue.scenario})))},

function(s){return s.employeeId}];


const _takeoffFatigueAndThresholdStatusSort=[
'takeoff.fatigue',
_getSortCounterFor('schedule','above-threshold'),
_getSortCounterFor('schedule','at-threshold')];



const _getThresholdStatusFromFatigueAndThreshold=function(fatigue,threshold){
const thresholdDiff=fatigue-threshold;
return thresholdDiff>=0?
'above-threshold':
thresholdDiff>=-1?
'at-threshold':
'below-threshold';
};

const _addThresholdStatusesToTOD=function(tod,subprop,threshold){
if(!_.exists(tod.fatigue[subprop])){
return;
}

const thresholdStatus=_getThresholdStatusFromFatigueAndThreshold(tod.fatigue[subprop],threshold);

_.set(tod,`thresholdStatus["${subprop}"]`,thresholdStatus);
};

const _addThresholdStatusesToPeak=function(peak,subprop,threshold){
const peakFatigue=_.get(peak,`${subprop}.fatigue`);
if(!_.exists(peakFatigue)){
return;
}

const thresholdStatus=_getThresholdStatusFromFatigueAndThreshold(peakFatigue,threshold);

_.set(peak,`${subprop}.thresholdStatus`,thresholdStatus);
};

const _inflateTrips=function(trips,threshold){
return(trips||[]).map(function(trip){
_addThresholdStatusesToTOD(trip.tod,'scenario',threshold);
_addThresholdStatusesToTOD(trip.tod,'original',threshold);
_inflateStartAndEndDates(trip);
return new TripViewModel(trip);
});
};

const _inflateDuties=function(duties,threshold){
return(duties||[]).map(function(duty){
_addThresholdStatusesToPeak(duty.peak,'scenario',threshold);
_addThresholdStatusesToPeak(duty.peak,'original',threshold);
_inflateStartAndEndDates(duty);
return new DutyViewModel(duty);
});
};

const _withIndexAssigned=function(result,index){return _.assign(result,{index:index})};

const _inflateTakeoff=function(takeoff,threshold){
const thresholdStatus=_getThresholdStatusFromFatigueAndThreshold(takeoff.fatigue,threshold);
return _.assign(takeoff,{thresholdStatus:thresholdStatus});
};



module.exports=EmiratesSearchService;
module.exports.inflateIndividualsResultsFromBackend=inflateIndividualsResultsFromBackend;
//# sourceMappingURL=emiratesSearchService.js.map
